// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f5ca121","239":"1f28d923","453":"7e08da67","455":"4ec603aa"}[chunkId] + ".chunk.js";
};